import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import Modal from "./Modal";
import {useSubmitGuard} from "../Helpers";


export function ConfirmationModal(props) {

const [confirmation, setConfirmation] = useState("");
const {isSubmitting, guardedSubmit} = useSubmitGuard();

const enterConfirmation = (e) => {
    setConfirmation(e.target.value)
}

const handleCancel = (e) => {
    e.preventDefault();
    props.handleClose(e)
}

const handleSubmit = guardedSubmit((e) => props.onSubmit(e));

    return (
        <Modal blurBack={true} hasCloseButton={true} handleClose={(e) => props.handleClose(e)} >
            {props.children}
            <form className="form" onSubmit={handleSubmit}>
                <div className="inputs-wrapper gap-below-s">
                    <div className="input-basic">
                        <input
                            type="text"
                            name="confirmation"
                            onChange={(e) => enterConfirmation(e)}
                            value={confirmation}
                            id="confirmation"
                            required
                        />
                        <label htmlFor="confirmation">confirm</label>
                    </div>
                </div>
                <div className="flex-row ">
                    <button
                        id="submit_confirm"
                        className="iblock btn expand pri gap-right-xs tb"
                        disabled={confirmation !== "confirm" || isSubmitting}
                        type="submit"
                    >{isSubmitting ? "Please wait..." : props.proceedButtonText}</button>
                    <button className="iblock btn expand sec" disabled={isSubmitting} onClick={(e) => handleCancel(e)} >Cancel</button>
                </div>
            </form>
        </Modal>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(ConfirmationModal);